import { epic$, store } from '@redux/store';
import uiStateSlice from 'layout/redux/uiStateSlice';
import generateGUID from 'utils/guidGenerator';
import { getBuildeablePlanEpic, getCommunityEpic, getPlanEpic, getSpecEpic } from './redux/epics';

epic$.next(getBuildeablePlanEpic);
epic$.next(getCommunityEpic);
epic$.next(getPlanEpic);
epic$.next(getSpecEpic);

export default (id, type) => {
  store.dispatch(uiStateSlice.actions.modalInformation({
    id,
    type,
    name: 'leadModal',
    guid: generateGUID(),
  }));
};

require('./components/extendedCard');
